import React from 'react'

import { Box, BoxProps } from '../Box'

const containerSizes = {
  xs: '840px',
  sm: '1080px',
  md: '1280px',
  lg: '1480px',
  xl: '1680px',
}

export interface ContainerProps extends Omit<BoxProps, 'size'> {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export function Container({
  size = 'md',
  width = '100%',
  px = [5, null, 6, 8],
  mx = 'auto',
  ...restProps
}: ContainerProps) {
  return (
    <Box width={width} px={px} mx={mx} {...restProps} maxWidth={containerSizes[size] || size} />
  )
}

export default Container
